import { render, staticRenderFns } from "./DxCamera.vue?vue&type=template&id=2be249fa&scoped=true"
import script from "./DxCamera.vue?vue&type=script&lang=js"
export * from "./DxCamera.vue?vue&type=script&lang=js"
import style0 from "./DxCamera.vue?vue&type=style&index=0&id=2be249fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be249fa",
  null
  
)

export default component.exports